import React, { useState } from 'react';
import { Box, TextField, Button, Grid, Alert, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { calculateHash } from '../utils/garantiPos';
import { useAuth } from '../contexts/AuthContext';
import sha1 from 'crypto-js/sha1';
import sha512 from 'crypto-js/sha512';
import Hex from 'crypto-js/enc-hex';

const CreditCardPayment = ({ 
  amount, 
  orderId, 
  customerEmail, 
  customerIP,
  installmentCount,
  onPaymentComplete 
}) => {
  const { currentUser } = useAuth();
  const [cardData, setCardData] = useState({
    cardHolder: '',
    cardNumber: '',
    expireMonth: '',
    expireYear: '',
    cvv: '',
    installment: '0'
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Hash hesaplama fonksiyonları
  const calculateSecure3DHash = () => {
    // 1. HashedPassword hesaplama
    const provisionPassword = "Metro12"; 
    const terminalId = "10328068";
    const hashPasswordString = provisionPassword + "0" + terminalId;
    // hashPasswordString = "Metro12010328068" olacak
    const hashedPassword = sha1(hashPasswordString).toString(Hex);
    // hashedPassword = "2F8E778A864E1EBF23689C3EDD803C062ABAB683" olacak
    
    // 2. Secure3dhash için string oluşturma - tam olarak verilen sırada
    const hashString = 
      terminalId + // "10328068"
      orderId + 
      amount + // işlem tutarı (örn: "100")
      "949" + // para birimi kodu
      "https://garantibbvapos.com.tr/destek/postback.aspx" + // success URL
      "https://garantibbvapos.com.tr/destek/postback.aspx" + // error URL
      "sales" + // işlem tipi
      (installmentCount > 1 ? installmentCount : '') + // taksit sayısı (peşin için boş)
      "dc0bfd7b5b0ea205f341ed139b8a89352806115529db9c1" + // storeKey
      hashedPassword; // yukarıda hesaplanan hashedPassword

    // 3. Son hash hesaplama - SHA512 ve büyük harfe çevirme
    return sha512(hashString).toString(Hex).toUpperCase();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      if (!orderId) {
        throw new Error('Sipariş numarası bulunamadı');
      }

      // Form oluştur
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = 'https://sanalposprov.garanti.com.tr/servlet/gt3dengine';

      const formFields = {
        secure3dsecuritylevel: '3D_PAY',
        mode: 'PROD',
        apiversion: '512',
        terminalprovuserid: 'PROVAUT',
        terminaluserid: 'SANALUSER',
        terminalmerchantid: '2828232',
        txntype: 'sales',
        txnamount: amount,
        txncurrencycode: '949',
        txninstallmentcount: installmentCount > 1 ? installmentCount : '',
        customeremailaddress: customerEmail,
        customeripaddress: customerIP,
        orderid: orderId,
        terminalid: '10328068',
        successurl: 'https://garantibbvapos.com.tr/destek/postback.aspx',
        errorurl: 'https://garantibbvapos.com.tr/destek/postback.aspx',
        companyname: 'GARANTI TEST',
        lang: 'tr',
        secure3dhash: calculateSecure3DHash(),
        txntimestamp: new Date().toLocaleString('tr-TR'),
        refreshtime: '5',
        cardnumber: cardData.cardNumber.replace(/\s/g, ''),
        cardexpiredatemonth: cardData.expireMonth.padStart(2, '0'),
        cardexpiredateyear: cardData.expireYear.slice(-2),
        cardcvv2: cardData.cvv,
        puani: ''
      };

      // Form alanlarını ekle
      Object.entries(formFields).forEach(([key, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.id = key;
        input.value = value;
        form.appendChild(input);
      });

      // Formu gönder
      document.body.appendChild(form);
      form.submit();
      document.body.removeChild(form);

    } catch (error) {
      console.error('Ödeme hatası:', error);
      setError('Ödeme işlemi sırasında bir hata oluştu');
      setLoading(false);
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Kart Üzerindeki İsim"
            value={cardData.cardHolder}
            onChange={(e) => setCardData({...cardData, cardHolder: e.target.value})}
            required
          />
        </Grid>
        
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Kart Numarası"
            value={cardData.cardNumber}
            onChange={(e) => setCardData({...cardData, cardNumber: e.target.value})}
            inputProps={{ maxLength: 16 }}
            required
          />
        </Grid>
        
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label="Son Kullanma Ay"
            value={cardData.expireMonth}
            onChange={(e) => setCardData({...cardData, expireMonth: e.target.value})}
            inputProps={{ maxLength: 2 }}
            required
          />
        </Grid>
        
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label="Son Kullanma Yıl"
            value={cardData.expireYear}
            onChange={(e) => setCardData({...cardData, expireYear: e.target.value})}
            inputProps={{ maxLength: 2 }}
            required
          />
        </Grid>
        
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label="CVV"
            value={cardData.cvv}
            onChange={(e) => setCardData({...cardData, cvv: e.target.value})}
            inputProps={{ maxLength: 3 }}
            required
          />
        </Grid>
        
        <Grid item xs={12}>
          <FormControl fullWidth>
            <InputLabel>Taksit Seçeneği</InputLabel>
            <Select
              value={cardData.installment}
              onChange={(e) => setCardData({...cardData, installment: e.target.value})}
              label="Taksit Seçeneği"
            >
              <MenuItem value="0">Tek Çekim</MenuItem>
              <MenuItem value="2">2 Taksit</MenuItem>
              <MenuItem value="3">3 Taksit</MenuItem>
              <MenuItem value="6">6 Taksit</MenuItem>
              <MenuItem value="9">9 Taksit</MenuItem>
              <MenuItem value="12">12 Taksit</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      
      <Button
        type="submit"
        fullWidth
        variant="contained"
        disabled={loading}
        sx={{ mt: 3 }}
      >
        {loading ? 'İşleminiz Yapılıyor...' : 'Ödemeyi Tamamla'}
      </Button>

      {error && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {error}
        </Alert>
      )}
    </Box>
  );
}

export default CreditCardPayment; 